//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    DASHBOARD_PANEL_DELETE_GADGET_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    deleteGadgetResult,
} from 'Redux/actions';


function* deleteGadgetDashboardRequest({ payload }) {
    try {
        const { id } = payload;
        let query = `
            mutation deleteUserGadget ($id: String!) {
                result: deleteUserGadget (id: $id)
            }
          `;
        const data = yield call(
            clientMutation,
            query,
            { id: id },
            endpoints.GRAPHQL_GENERAL
        );

        yield put(deleteGadgetResult({ data: data.result }));
    } catch (exc) {
        yield put(deleteGadgetResult({ error: true }));
        ExceptionManager(
            exc,
            "Modules/dashboard/views/.components/chart/.components/deleteChart/redux/saga",
            "deleteGadgetDashboardRequest"
        );
    }
}
function* watchDashboardPanelRequests() {
    yield takeEvery(DASHBOARD_PANEL_DELETE_GADGET_REQUEST, deleteGadgetDashboardRequest);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchDashboardPanelRequests)
    ]);
}